import { type FC } from 'react';
import { type TicketmasterRecommendation } from '../types';
import { RecommendationCard } from './RecommendationCard';

interface Props {
  readonly ticketmaster: TicketmasterRecommendation;
}

export const TicketmasterCard: FC<Props> = ({
  ticketmaster: { name, url, image_url, venue, venue_url, info, formatted_datetime },
}) => (
  <RecommendationCard
    name={name}
    url={url}
    image={image_url ? { uri: image_url, altText: 'Image provided by Ticketmaster.' } : null}
    address={venue ? { formattedAddress: venue, mapsUrl: venue_url } : null}
    dateTime={formatted_datetime}
    description={info}
  />
);
TicketmasterCard.displayName = 'TicketmasterCard';
